export function initializeShowMore() {
    // Handle Show More for Leaderboard
    $(document).on('click', '.show-more-leaderboard', function(e) {
        e.preventDefault();

        const $button = $(this);

        // Prevent multiple concurrent requests
        if ($button.data('loading')) {
            return;
        }

        const $container = $button.closest('[id^="block-"]');
        const blockUuid = $button.data('block');
        const level = $button.data('level');
        const page = $button.data('page');

        // Show loading state
        const originalText = $button.text();
        $button.prop('disabled', true).text(originalText.replace(/Show more/, 'Loading')).data('loading', true);

        // Get the action URL from the original form or construct it
        let actionUrl = $container.find('form').first().attr('action');
        if (!actionUrl) {
            // Fallback - get action URL from the container's data attribute
            actionUrl = $container.data('action');
        }

        $.ajax({
            type: 'POST',
            url: actionUrl,
            data: {
                level: level,
                page: page,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function(data) {
                if (data.view) {
                    // The incremental response now contains only the new content
                    const $newContent = $(data.view);

                    // Find the target container on the current page
                    const $blockContainer = $container;

                    // Determine if we're in table or card mode and find the right container
                    let $currentTable = null;
                    let $currentCards = null;

                    // First check for simplified leaderboard (table mode)
                    // For table mode, the button is INSIDE the collapse section
                    const $collapseSection = $button.closest('.collapse');
                    if ($collapseSection.length > 0) {
                        $currentTable = $collapseSection.find('tbody').first();
                    }

                    // If no table found, check for card mode (non-simplified leaderboard)
                    // For card mode, the button is a SIBLING of the cards container
                    if ($currentTable === null || $currentTable.length === 0) {
                        // Look for cards container as a sibling (previous sibling)
                        $currentCards = $button.prev('.leaderboard-cards-container');

                        if ($currentCards.length === 0) {
                            // Fallback: look for cards container anywhere in the block
                            $currentCards = $blockContainer.find('.leaderboard-cards-container').first();
                        } else {
                        }
                    }

                    // Extract and append the new content
                    let hasNewContent = false;

                    if ($currentTable !== null && $currentTable.length > 0) {
                        // Find new table rows in the response (direct <tr> elements)
                        const $newRows = $newContent.filter('tr').add($newContent.find('tr'));

                        if ($newRows.length > 0) {
                            // Additional check to prevent duplication: compare with existing content
                            let $validNewRows = $newRows.filter(function() {
                                const newRowHtml = $(this).html();
                                let isDuplicate = false;

                                $currentTable.find('tr').each(function() {
                                    if ($(this).html() === newRowHtml) {
                                        isDuplicate = true;
                                        return false; // break the loop
                                    }
                                });

                                return !isDuplicate;
                            });

                            if ($validNewRows.length > 0) {
                                $currentTable.append($validNewRows);
                                hasNewContent = true;
                            }
                        }
                    } else if ($currentCards !== null && $currentCards.length > 0) {
                        // Find new card columns in the response (direct .col-12 elements)
                        const $newCards = $newContent.filter('.col-12').add($newContent.find('.col-12')).not(':has(.show-more-leaderboard)');

                        if ($newCards.length > 0) {
                            // Additional check to prevent duplication: compare with existing content
                            let $validNewCards = $newCards.filter(function() {
                                const newCardHtml = $(this).html();
                                let isDuplicate = false;

                                $currentCards.find('.col-12').each(function() {
                                    if ($(this).html() === newCardHtml) {
                                        isDuplicate = true;
                                        return false; // break the loop
                                    }
                                });

                                return !isDuplicate;
                            });

                            if ($validNewCards.length > 0) {
                                $currentCards.append($validNewCards);
                                hasNewContent = true;
                            }
                        }
                    }

                    // Handle Show More button state
                    const $newShowMore = $newContent.filter('.show-more-leaderboard').add($newContent.find('.show-more-leaderboard'));

                    if ($newShowMore.length > 0 && hasNewContent) {
                        const nextPage = $newShowMore.first().data('page');
                        $button.data('page', nextPage);
                    } else {
                        $container.find('.show-more-leaderboard').addClass('d-none');
                    }
                } else {
                    // If data.isShowMore is false, it means there are no more results
                    // Hide the button completely
                    if (!data.isShowMore) {
                        $container.find('.show-more-leaderboard').addClass('d-none');
                    } else {
                        $container.html(data.view);
                        initializeShowMore();
                    }
                }
            },
            error: function(xhr, status, error) {
                //
            },
            complete: function() {
                // Restore button state regardless of success or error, but respect if it should be hidden
                if (!$button.data('should-hide')) {
                    $button.prop('disabled', false).text(originalText).removeData('loading');
                } else {
                    $button.removeData('loading');
                }
            }
        });
    });

    // Handle Show More for Participants
    $(document).on('click', '.show-more-participants', function(e) {
        e.preventDefault();

        const $button = $(this);

        // Prevent multiple concurrent requests
        if ($button.data('loading')) {
            return;
        }

        const $participantContainer = $button.closest('.participant-listing-container');
        const $mainContainer = $participantContainer.parent();
        const blockUuid = $button.data('block');
        const listing = $button.data('listing');
        const search = $button.data('search');
        const page = $button.data('page');

        // Show loading state
        const originalText = $button.text();
        $button.prop('disabled', true).text(originalText.replace(/Show more/, 'Loading')).data('loading', true);

        // Find the form to get the action URL
        const $form = $mainContainer.find('form').first();
        const actionUrl = $form.attr('action');

        $.ajax({
            type: 'POST',
            url: actionUrl,
            data: {
                listing: listing,
                search: search,
                page: page,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function(data) {
                if (data.view) {
                    const $newContent = $(data.view);
                    const $currentRow = $participantContainer.find('.row.gy-3').first();

                    // Extract new participant cards and filter out duplicates
                    const $newItems = $newContent.find('.row.gy-3 .col-lg-6').not(':has(.show-more-participants)');

                    // Additional check to prevent duplication: compare with existing content
                    let $validNewItems = $newItems.filter(function() {
                        const newItemHtml = $(this).html();
                        let isDuplicate = false;

                        $currentRow.find('.col-lg-6').each(function() {
                            if ($(this).html() === newItemHtml) {
                                isDuplicate = true;
                                return false; // break the loop
                            }
                        });

                        return !isDuplicate;
                    });

                    // Only append if we actually have new, non-duplicate items
                    if ($validNewItems.length > 0) {
                        $currentRow.append($validNewItems);
                    }

                    // Check if there are more results by looking for a new show more button in the response
                    const $newShowMore = $newContent.find('.show-more-participants');

                    // Only update the button if we have both a new show more button AND actual new content was added
                    if ($newShowMore.length && $validNewItems.length > 0) {
                        // Update the current button for the next page only if we have new items
                        const nextPage = $newShowMore.data('page');
                        $button.data('page', nextPage);
                    } else {
                        // No more results or no new items - hide the button
                        console.log('HIDE THE BUTTON1');
                        $participantContainer.find('.show-more-participants').addClass('d-none');
                    }
                } else {
                    // If data.isShowMore is false, it means there are no more results
                    // Hide the button completely
                    if (!data.isShowMore) {
                        $participantContainer.find('.show-more-participants').addClass('d-none');
                    } else {
                        $participantContainer.html(data.view);
                        initializeShowMore();
                    }
                }
            },
            error: function(xhr, status, error) {
                //
            },
            complete: function() {
                // Restore button state regardless of success or error, but respect if it should be hidden
                if (!$button.data('should-hide')) {
                    $button.prop('disabled', false).text(originalText).removeData('loading');
                } else {
                    $button.removeData('loading');
                }
            }
        });
    });
}
